{
  "SET_NEW_PASSWORD": {
    "TITLE": "Установить новый пароль",
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль слишком короткий."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Подтвердите пароль",
      "PLACEHOLDER": "Подтвердить пароль",
      "ERROR": "Пароли не совпадают."
    },
    "API": {
      "SUCCESS_MESSAGE": "Пароль изменен.",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
    },
    "CAPTCHA": {
      "ERROR": "Время проверки истекло. Пожалуйста, решите задачу captcha еще раз."
    },
    "SUBMIT": "Отправить"
  }
}
